// https://en.wikipedia.org/wiki/IETF_language_tag
// https://www.venea.net/web/culture_code

export enum LanguageCode {
  Swedish = 'sv', // Sweden sv-SE
  Norwegian = 'no', // Norway no-NO
  Danish = 'da', // Denmark da-DK
  // NorwegianBokmal = 'nb-no', // Norway nb-NO
  // NorwegianNynorsk = 'nn-no', // Norway nb-NO
  // Finnish = 'fi', // Finland fi-FI
  // English = 'en', // English en-US
}
